export enum AcEnumDDFieldFormat {
    date = "date",
    encrypt = "encrypt",
    hideField = "hide_field",
    json = "json",
    lowercase = "lowercase",
    uppercase = "uppercase"
}